import React, { useEffect, useState, useMemo } from "react";
import Select from 'react-select';
import he from 'he';
import { useLocation } from "react-router-dom";
import FilterSearch from "./FilterSearch";
import GlobalContext from "../GlobalContext";

import './Filters.css';

function Filters(){
  const global = React.useContext(GlobalContext);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectKey, setSelectKey] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  // Get the "cat" query parameter
  const categoriesParam = queryParams.get('cat');
  const queryParam = queryParams.get('query');

  const themeOverride = theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#a10c11',
      primary25: '#a10c1122',
      neutral20: '#333', // Border color
      neutral30: '#111'  // Border color on hover
    }
  });

  const createOptions = (categories, depth = 0) => {
    return categories.flatMap(category => {
      const options = [{
        value: category.slug,
        label: he.decode('&nbsp;— '.repeat(depth) + category.name)
      }];
  
      if (category.children && category.children.length > 0) {
        options.push(...createOptions(category.children, depth + 1));
      }
  
      return options;
    });
  };
  
  // Initialize options state with an empty array
  const [options, setOptions] = useState([]);

  // Update options state when filterCategories data is available
  useEffect(() => {
    if (Object.keys(global.state.filterCategories).length > 0) {
      setOptions(createOptions(global.state.filterCategories));
    }
  }, [global.state.filterCategories]);

  useEffect(() => {
    if (categoriesParam && categoriesParam.length > 0 && options.length > 0) {
      // Decode the HTML-encoded string and split it into an array
      const categoriesSelected = decodeURIComponent(categoriesParam).split(',');
      // Find the options that match the categories from the query string
      const newSelectedOptions = options.filter(option => categoriesSelected.includes(option.value));
      setSelectedOptions(newSelectedOptions);
      setSelectKey(prevKey => prevKey + 1);
      // Trigger the onChange handler manually
      global.actions.changeFilter(newSelectedOptions);
    }
  }, [categoriesParam, options]);

  return (
    <div className="filters">
      <FilterSearch queryParam={queryParam} />
      <Select
        key={selectKey} 
        isMulti
        defaultValue={ selectedOptions }
        placeholder='Select a category'
        name='filter-category'
        onChange={ global.actions.changeFilter }
        options={ options }
        className="categories-select"
        classNamePrefix="select"
        theme={ themeOverride }
      />
    </div>
  );
}

export default Filters;